import { Injectable } from '@angular/core';
import { ProjectService } from '../../modules/project/services/project.service';
import { SectionService } from '../../modules/section/services/section.service';
import { ProjectTaskService } from '../../modules/projectTask/services/projectTask.service';
import { MileStoneService } from '../../modules/mileStone/services/mileStone.service';

@Injectable({
  providedIn: 'root',
})
export class LookupService {
  constructor(
    private sectionService: SectionService,
    private projectService: ProjectService,
    private mileStoneService: MileStoneService,
    private projectTaskService: ProjectTaskService
  ) {}

  // Fetch data from respective services
  private async fetchSections(): Promise<any> {
    return this.sectionService.getLookup().toPromise();
  }

  private async fetchProjects(): Promise<any> {
    return this.projectService.getListLookup().toPromise();
  }

  private async fetchMilestones(): Promise<any> {
    return this.mileStoneService.getLookup().toPromise();
  }

  private async fetchTasks(): Promise<any> {
    return this.projectTaskService.getListLookup().toPromise();
  }

  // Fetch and cache lookup data
  async updateCache(): Promise<void> {
    try {
      const [sections, projects, milestones, tasks] = await Promise.all([
        this.fetchSections(),
        this.fetchProjects(),
        this.fetchMilestones(),
        this.fetchTasks(),
      ]);

      // Save data to local storage
      localStorage.setItem('sections', JSON.stringify(sections));
      localStorage.setItem('projects', JSON.stringify(projects));
      localStorage.setItem('milestones', JSON.stringify(milestones));
      localStorage.setItem('tasks', JSON.stringify(tasks));
    } catch (error) {
      console.error('Error fetching lookup data:', error);
    }
  }

  // Load data from local storage
  loadFromCache(key: string): any[] {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : [];
  }
}
